import { FontCategory } from '@quicktools/shared-components/data/fonts';

import { CATEGORIES, RECENT_CATEGORY } from '../../constants';

export default function getGeneratorHeading(selectedCategory: FontCategory) {
  const currentFontCategory = CATEGORIES[selectedCategory];

  if (currentFontCategory) {
    return currentFontCategory.headingText || currentFontCategory.text;
  }

  return RECENT_CATEGORY.text;
}
